module.exports = __webpack_public_path__ + "static/media/ic_video.a07e40e2.svg";